// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"325dffa4","513":"64a50e65","703":"3be34c98","787":"f019d0be"}[chunkId] + ".chunk.js";
};